import apiClient from '../client';
import type { CandidateListAPIV2 } from '../../types';

// NOTE: `baseURL` override is a temporary workaround until the apiClient is
// refactored to use `/api` as base and embed the version in the path.
// Same caveat as api/v2/tenders.ts.
const V2_BASE = '/api/v2';

/**
 * Fetch candidates for a tender whose skill-match meets the backend's
 * threshold (currently 0.75). Returns `null` when the tender does not
 * exist (404). Any other non-2xx response is thrown by the apiClient
 * interceptor.
 */
export async function fetchCandidatesV2(tenderId: string): Promise<CandidateListAPIV2 | null> {
  const response = await apiClient.get<CandidateListAPIV2>(
    `/tenders/${tenderId}/candidates`,
    {
      baseURL: V2_BASE,
      validateStatus: (status) => status === 200 || status === 404,
    },
  );
  if (response.status === 404) return null;
  return response.data;
}
